module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Cardboard-vr-0214b6990aa2d5245e9ac952fc7f4537.svg";